import React from "react";
import fields from "../../json/BrandLogoListFields.json";
import FormInput from "Common/Custom/FormInput";
import FormInputFile from "Common/Custom/FormInputFile";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const AddBrandLogoForm = ({
  values,
  errors,
  handleChange,
  handleFileChange,
  handleSubmit,
  loading,
  imagePreview
}) => {
  const { formdata } = fields;
  return (
    <PageBody
      onSubmit={handleSubmit}
      headerchildren={<HeadingOne>Create Brand Logo</HeadingOne>}
    >
      {formdata.map((field) => {
        if (field.type === "file") {
          return (
            <FormInputFile
              field={field}
              handleChange={handleFileChange}
              error={errors.brand_logo}
              imagePreview={imagePreview}
            />
          );
        }

        // Default input

        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}


      <FormSubmitButton
        label="Create"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default AddBrandLogoForm;